export function Spinner({
  size = 5,
  light = false,
}: {
  size?: number;
  light?: boolean;
}) {
  return (
    <div
      className="border-2 rounded-full animate-spin"
      style={{
        width: `${size * 4}px`,
        height: `${size * 4}px`,
        borderColor: light ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.12)",
        borderTopColor: light ? "#ffffff" : "#111111",
      }}
    />
  );
}
